var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70.28mm",
    height: "13.278mm",
    viewBox: "0 0 265.62 50.186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 275.4,
    x2: 364.68,
    y1: 79.574,
    y2: 79.574,
    gradientTransform: "translate(-13.821 607.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f66c0d",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-262.93 -662.42)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.8795 0 0 1.6981 -136.08 1902.4)",
    d: "m270.87-703.59q-3.904 0-6.304-2.048-2.368-2.08-2.368-5.664h4.896q0 0.8 0.288 1.44 0.32 0.608 0.832 0.992 0.544 0.384 1.216 0.576t1.408 0.192q1.472 0 2.528-0.704 1.088-0.704 1.088-1.92 0-0.512-0.256-0.896-0.256-0.416-0.608-0.64-0.32-0.256-1.024-0.512-0.672-0.256-1.152-0.384t-1.44-0.352q-0.768-0.192-1.152-0.288t-1.152-0.32q-0.736-0.224-1.152-0.384-0.384-0.192-1.024-0.512t-0.992-0.64-0.8-0.8q-0.416-0.48-0.64-0.992-0.224-0.544-0.384-1.216-0.16-0.704-0.16-1.472 0-3.2 2.176-4.96t5.952-1.76q3.808 0 5.92 1.92 2.144 1.92 2.144 5.28h-4.8q0-1.376-0.992-2.08-0.96-0.736-2.4-0.736-1.28 0-2.24 0.544-0.928 0.544-0.928 1.568 0 0.48 0.224 0.864 0.256 0.352 0.576 0.608 0.32 0.224 0.992 0.48 0.672 0.224 1.12 0.352 0.48 0.096 1.408 0.32 1.024 0.256 1.536 0.416 0.512 0.128 1.472 0.48 0.96 0.32 1.472 0.64 0.544 0.32 1.248 0.864 0.704 0.512 1.056 1.152 0.384 0.608 0.64 1.504 0.288 0.864 0.288 1.888 0 2.336-1.184 4t-3.072 2.432q-1.856 0.768-4.256 0.768zm27.619-22.848v4.512h-6.24v17.888h-4.864v-17.888h-6.208v-4.512zm15.747 22.4-4.352-7.648h-3.104v7.648h-4.864v-22.4h9.056q2.208 0 4 0.96 1.792 0.928 2.784 2.624 1.024 1.696 1.024 3.84t-1.088 3.872-2.976 2.624l4.96 8.48zm-7.456-17.92v5.792h3.872q1.472 0 2.336-0.8 0.896-0.8 0.896-2.08 0-0.864-0.384-1.504-0.384-0.672-1.12-1.024-0.736-0.384-1.728-0.384zm26.115 6.208h11.936q-0.032 5.312-3.232 8.768-3.2 3.424-8.224 3.424-4.96 0-8.288-3.296-3.296-3.328-3.296-8.352 0-5.056 3.264-8.384t8.224-3.328q4.192 0 7.328 2.4 3.136 2.368 3.904 6.144h-4.992q-0.48-1.216-1.376-2.08-0.896-0.896-2.144-1.376-1.216-0.48-2.624-0.48-2.976 0-4.832 1.984t-1.856 5.12q0 2.048 0.832 3.648t2.336 2.496q1.536 0.896 3.52 0.896 1.44 0 2.72-0.48t2.176-1.344q0.928-0.896 1.344-2.016h-6.72zm15.875 11.712v-22.4h4.864v22.4z",
    fill: "#fff",
    strokeWidth: 0.75,
    style: {
      inlineSize: 149.427,
      whiteSpace: "pre"
    },
    "aria-label": "STRGI"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m279.68 712.6-16.75-25.093 16.938-25.093h15.056l-16.938 25.093 9.7863 14.585 29.359-39.678h15.432l16.938 25.093-16.938 25.093h-15.056l16.938-25.093-9.7861-14.428-29.171 39.521z",
    fill: "url(#a)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.164c55f10f8a9d7bc87e247f09c7488d.svg";
export { ForwardRef as ReactComponent };